import React, { createContext, useContext } from "react";

export const ChannelInfoContext = createContext(null);

const ChannelInfoProvider = props => <ChannelInfoContext.Provider {...props} />;
export default ChannelInfoProvider;

const useChannelInfoOptions = () => {
  const context = useContext(ChannelInfoContext);
  return context;
};

export { useChannelInfoOptions };
